import { format } from 'date-fns';

import { EMPTY_PLACEHOLDER } from './Forms/constants';

export const formatDate = (value?: Date | null) => {
    return value ? format(value, 'yyyy-MM-dd') : EMPTY_PLACEHOLDER;
};
